import React, { useState, useRef, useEffect } from "react";
import styles from "./AudioPlayer.module.css";
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa";
import twitterAudio from "../../../assets/twitterSpace/baai-twitter-space.mp3";
import { Button, Tooltip } from "antd";

const AudioPlayer = () => {
  // state
  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState(5049);
  const [currentTime, setCurrentTime] = useState(0);
  //   const { timeJump } = useParams()
  const chapters = [
    {
      start: 0,
      end: 257,
      top :'',
      height :'',
    },
    {
      start: 258,
      end: 596,
      title: "Emotionally Intelligent AI",
      top :-55,
      height :45,
    },
    {
      start: 597,
      end: 969,
      title: "BrainAlive AI Model",
      top :-35,
      height :25,
    },
    {
      start: 970,
      end: 3196,
      title: "BAAI & Emotional Intelligence",
      top :-19,
      height :9,
    },
    {
      start: 3197,
      end: 3754,
      title: "About BrainAlive",
      top :-45,
      height :35,
    },
    {
      start: 3755,
      end: duration,
      title: "AMA",
      top :-19,
      height :9,
    },
  ];

  // references
  const audioPlayer = useRef(); // reference our audio component
  const progressBar = useRef(); // reference our progress bar
  const animationRef = useRef(); // reference the animation

  // useEffect(() => {
  //   audioPlayer.current.load()
  // }, [])

  useEffect(() => {
    const seconds = Math.floor(audioPlayer.current.duration);
    // setDuration(seconds)
    progressBar.current.max = seconds;
  }, [audioPlayer?.current?.loadedmetadata, audioPlayer?.current?.readyState]);

  const calculateTime = (secs) => {
    const hours = Math.floor(secs / 3600);
    const minutes = Math.floor((secs % 3600) / 60);
    const seconds = Math.floor(secs % 60);

    const returnedHours = hours < 10 ? `0${hours}` : `${hours}`;
    const returnedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;

    if (returnedHours > 0)
      return `${returnedHours}:${returnedMinutes}:${returnedSeconds}`;
    else return `${returnedMinutes}:${returnedSeconds}`;
  };

  const play = () => {
    audioPlayer.current.play();
    animationRef.current = requestAnimationFrame(whilePlaying);
  };

  const togglePlayPause = () => {
    const prevValue = isPlaying;
    setIsPlaying(!prevValue);
    if (!prevValue) {
      play();
    } else {
      audioPlayer.current.pause();
      cancelAnimationFrame(animationRef.current);
    }
  };

  const whilePlaying = () => {
    progressBar.current.value = audioPlayer.current.currentTime;
    changePlayerCurrentTime();
    animationRef.current = requestAnimationFrame(whilePlaying);
  };

  const changeRange = () => {
    audioPlayer.current.currentTime = progressBar.current.value;
    changePlayerCurrentTime();
  };

  const changePlayerCurrentTime = () => {
    progressBar.current.style.setProperty(
      "--seek-before-width",
      `${(progressBar.current.value / duration) * 100}%`
    );
    setCurrentTime(progressBar.current.value);
  };

  const timeTravel = (newTime) => {
    progressBar.current.value = newTime;
    changeRange();
    if (!isPlaying) {
      play();
      setIsPlaying(true);
    }
  };

  return (
    <>
      <div className={styles.playRecording}>
        <Button
          size="primary"
          shape="round"
          block
          onClick={() => togglePlayPause()}
        >
          {isPlaying ? <FaPause /> : <FaPlay className={styles.play} />}
          <strong className="ms-2">{isPlaying ? '   Pause ' : '   Play '} Recording</strong>
        </Button>
      </div>
      <div className={styles.wrappers}>
        <div className={styles.audioPlayer}>
          <audio
            ref={audioPlayer}
            src={twitterAudio}
            preload="auto"
          ></audio>

          {/* current time */}
          <div className={styles.currentTime}>{calculateTime(currentTime)}</div>

          {/* progress bar */}
          <div className={styles.progressBarWrapper}>
            <input
              type="range"
              className={styles.progressBar}
              defaultValue="0"
              ref={progressBar}
              onChange={changeRange}
            />
            {!isNaN(duration) &&
              chapters.map((chapter, i) => {
                const leftStyle = (chapter.start / duration) * 100
                const widthStyle = ((chapter.end - chapter.start) / duration) * 100
                return (
                  <span key={i}>
                    <div
                      className={styles.title}
                      style={{
                        '--left': `${leftStyle}%`,
                        '--top': `${chapter.top}px`,
                        '--height': `${chapter.height}px`,
                        '--width': `${widthStyle}%`,
                      }}
                      onClick={() => timeTravel(chapter.start)}
                    >
                      <Tooltip title="Click to jump here!">
                        <span> {chapter.title}</span>
                      </Tooltip>
                      <p className="mb-0"> {chapter.start > 0 && calculateTime(chapter.start)}</p>
                    </div>
                    <div
                      key={i}
                      className={`${styles.chapter} ${chapter.start === 0 && styles.start} ${chapter.end === duration && styles.end}`}
                      style={{
                        '--left': `${leftStyle}%`,
                        '--width': `${widthStyle}%`,
                      }}
                    ></div>
                  </span>
                )
              })}
          </div>

          {/* duration */}
          <div className={styles.duration}>{!isNaN(duration) && `${calculateTime(Math.abs(duration - currentTime))}`}</div>
          <button
            onClick={togglePlayPause}
            className={styles.playPause}
          >
            {isPlaying ? <FaPause /> : <FaPlay className={styles.play} />}
          </button>
        </div>
      </div>
    </>
  )
};

export default AudioPlayer;
